import { useEffect } from 'react';

import { getSettings } from '../domain/settings/Settings';
import { setSettings, Settings } from '../store/settings';
import { toCountryCode } from '../types/CountryCode';
import { toLanguageCode } from '../types/LanguageCode';
import { useAppDispatch, useAppSelector } from './hooks';
import { useLocalePath } from './useLocalePath';

const useSettings = (): Settings => {
    const dispatch = useAppDispatch();
    const settings = useAppSelector((state) => state.settings);
    const { language, countryCode } = useLocalePath();

    // Refresh the settings based on country code and language
    useEffect(() => {
        const s = getSettings(toCountryCode(countryCode), toLanguageCode(language.toUpperCase()));
        dispatch(setSettings({ ...settings, ...s }));
    }, [countryCode, dispatch, language]);

    return settings;
};

export default useSettings;
